module.exports = __webpack_public_path__ + "static/img/Ice Cream.f02f746.png";